import React from 'react'
import CurrentQuestion from './CurrentQuestion'
import CurrentQuestionOption from './CurrentQuestionOption'

const CurrentQuestionAndAnswer = () => {
  return (
    <>
        <CurrentQuestion />
        <CurrentQuestionOption />
    </>
  )
}

export default CurrentQuestionAndAnswer